module.exports = new __parcel__URL__("reparent-onboarding-dark.d463727e.svg").toString();